import { Editor } from "@bryntum/schedulerpro";

// This editor is meant to finalize cell editing if input field is a combo box
// https://github.com/Swivu/swivu-client/issues/906
export default class SwivuCellEditor extends Editor {
  static get $name() {
    return "SwivuCellEditor";
  }

  static get type() {
    return "swivucelleditor";
  }

  async startEdit(editObject) {
    const result = super.startEdit(editObject);
    const me = this;

    if (result) {
      if (me.inputField.isCombo) {
        me.inputField.on({
          select() {
            me.owner.features.cellEdit.finishEditing();
          },
          once: true
        });
      }
    }

    return result;
  }
}
